module.exports = __webpack_public_path__ + "static/media/cascade-goal.1acc92de.svg";